import {
  FETCH_ASSETS_SUCCESS,
  FETCH_ASSETS_FAIL,
  FETCH_PAIRS_SUCCESS,
  FETCH_PAIRS_FAIL,
} from '../actions/types';

const initialState = {
  assets: {},
  pairs: {},
  errors: [],
};

const assets = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ASSETS_SUCCESS:
      return {
        ...state,
        assets: action.payload,
        loading: false,
      };
    case FETCH_ASSETS_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.payload,
      };
    case FETCH_PAIRS_SUCCESS:
      return {
        ...state,
        pairs: action.payload,
        loading: false,
      };
    case FETCH_PAIRS_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.payload,
      };
    default:
      return state;
  }
};

export default assets;
